import { render, staticRenderFns } from "./FormSelector.vue?vue&type=template&id=52287ba8&scoped=true&"
import script from "./FormSelector.vue?vue&type=script&lang=js&"
export * from "./FormSelector.vue?vue&type=script&lang=js&"
import style0 from "./FormSelector.vue?vue&type=style&index=0&id=52287ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52287ba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
